class CollapsibleHeader extends Collapsible {
  constructor() {
    super();
    this.header = this.closest("[data-header]");
    this.headerWrapper = this.closest("#shopify-section-header");
    if (this.header) {
      this.inverse = !!this.header.classList.contains("header--inverse");
      this.shadow = this.header.querySelector(".header-shadow");

      // extra events
      this.shadow?.addEventListener("click", this.closeAll.bind(this));
    }
  }
  
  events() {
    if (!this.header) {
      super.events();
    }
  }

  open(group) {
    super.open(group);
    if (this.headerWrapper) {
      this.headerWrapper.classList.add("shopify-section-header--open");
    }
    this.toggleHeaderClass(true);
  }

  close(group) {
    super.close(group);
    if (this.headerWrapper) {
      this.headerWrapper.classList.remove("shopify-section-header--open");
    }
    this.toggleHeaderClass(false);
  }

  closeSiblings(currentGroup = null) {
    super.closeSiblings(currentGroup);
    this.toggleHeaderClass(false);
  }

  openAll() {
    super.openAll();
    this.toggleHeaderClass(true);
    if (this.headerWrapper) {
      this.headerWrapper.classList.add("shopify-section-header--open");
    }
  }

  closeAll() {
    super.closeAll();
    this.toggleHeaderClass(false);
    if (this.headerWrapper) {
      this.headerWrapper.classList.remove("shopify-section-header--open");
    }
  }

  toggleHeaderClass(open = true) {
    if (!this.header) {
      return false;
    }

    if (open) {
      // set header open
      document.body.classList.add("header-is-open");
      this.inverse && this.header.classList.add("header--inverse-solid");
    } else {
      // set header closed if all menu items are closed
      let close = true;
      this.groups.forEach((group) => {
        if (group.classList.contains(this.options.toggleClass)) {
          close = false;
        }
      });
      if (close) {
        document.body.classList.remove("header-is-open");
        this.inverse && this.header.classList.remove("header--inverse-solid");
      }
    }
  }
}

class ToggleMobileNavigation extends ToggleElementClass {
  constructor() {
    super();

    this.header = this.closest("[data-header]");
    this.headerWrapper = this.closest("#shopify-section-header");

    if (this.header) {
      this.shadow = this.header.querySelector(".header-shadow");
      this.inverse = !!this.header.classList.contains("header--inverse");

      // Extra events
      document.addEventListener("keyup", (event) => {
        this.onKeyUp(event);
      });

      this.shadow?.addEventListener("click", (event) => {
        this.remove(event);
      });
    }
  }

  events() {
    if (!this.header) {
      super.events();
    }
  }

  onKeyUp(event) {
    if (!document.body.classList.contains("header-is-open")) {
      return;
    }
    if (event?.code.toUpperCase() !== "ESCAPE") {
      return;
    }
    const { toggleClass } = this.options;
    if (this.target?.classList.contains(toggleClass)) {
      this.remove();
    }
  }

  add() {
    super.add();
    trapFocus(this.header);
  }

  remove() {
    super.remove();
    this.closeAllSibblings();
    removeTrapFocus();
  }

  closeAllSibblings() {
    const collapsibles = this.target.querySelector("collapsible-element");
    collapsibles.closeAll();
  }
}

class ToggleSearch extends ToggleElementClass {
  constructor() {
    super();
  }

  construct() {
    super.construct();

    // elements
    this.header = this.closest("[data-header]");

    // options
    const { toggleClass, target } = this.options;

    // key up escape
    document.addEventListener("keyup", (event) => {
      this.onKeyUp(event);
    });

    // Remove classes incase the header navigation drawer is open.
    this.addEventListener("click", () => {
      document.body.classList.remove("header-is-open");
      document.body.classList.remove("menu-drawer-is-open");
      // click on element if provided
      if (this.options.clickTarget && window.innerWidth < 680) {
        document.querySelector(this.options.clickTarget).click();
      }
      let that = this;

      if (that.options.focusTarget) {
        let event = new KeyboardEvent("touchstart", { bubbles: true });
        let targetForFocus = document.querySelector(that.options.focusTarget);
        targetForFocus.focus();
        targetForFocus.dispatchEvent(event);
        // targetForFocus.addEventListener('touchstart', function(){
        //   console.log('triggered');
        // });
      }

      setTimeout(function () {
        document
          .querySelector(".aa-ClearButton")
          .addEventListener("click", function (event) {
            document.body.classList.remove("header-search-is-open");
            document.body.classList.remove("aa-Detached");
            document.querySelector(".aa-DetachedOverlay").remove();
          });
      }, 250);
    });

    this.onWindowResize();
    window.addEventListener("resize", this.throttle(this.onWindowResize, 200)); // throttle the resize event
  }

  throttle(func, limit) {
    let inThrottle = false;
    
    return function() {
      if (!inThrottle) {
        func.apply(this, arguments);
        inThrottle = true;
        
        setTimeout(function() {
          inThrottle = false;
        }, limit);
      }
    };
  }

  onWindowResize() {
    if (window.innerWidth > 1023) {
      // catch keyup and toggle helper class
      document.querySelectorAll(".aa-Input").forEach(function (input) {
        input.addEventListener("keyup", function () {
          if (this.value.length > 0) {
            document
              .querySelector("body")
              .classList.add("header-search-is-open");
          } else {
            document
              .querySelector("body")
              .classList.remove("header-search-is-open");
          }
        });
      });
    }
  }

  onKeyUp(event) {
    if (!document.body.classList.contains("header-search-is-open")) {
      return;
    }
    if (event?.code.toUpperCase() !== "ESCAPE") {
      return;
    }
    const { toggleClass } = this.options;
    if (this.target?.classList.contains(toggleClass)) {
      this.remove();
    }
  }

  add() {
    super.add();
    if (this.header) {
      document.body.classList.add("header-search-is-open");
    }
    if (this.target) {
      trapFocus(this.target);
    }
  }

  remove() {
    super.remove();
    if (this.header) {
      document.body.classList.remove("header-search-is-open");
    }
    removeTrapFocus();
  }
}

class AnnouncementBar extends HTMLElement {
  constructor() {
    super();
  }

  // Temporarely hide the announcement bar
  hide() {
    document.body.classList.remove("announcement-bar-visible");
  }

  // Reveal the announcement bar
  reveal() {
    document.body.classList.add("announcement-bar-visible");
  }

  // Hide the announcement bar for the rest of this session
  sessionHide() {
    document.body.classList.remove('announcement-bar-show');
    document.body.classList.add('announcement-bar-hide');
    // trigger setHeaderHeight on stickyheader
    const stickyHeader = document.querySelector('sticky-header');
    if (stickyHeader) {
      stickyHeader.setHeaderHeight();
    }
  }
}

class StickyHeader extends HTMLElement {
  constructor() {
    super();

    // select element
    this.headerElement = this;
    this.header = document.querySelector("[data-header]");
    this.headerWrapper = document.querySelector("#shopify-section-header");
    this.announcementBar = document.querySelector("announcement-bar");
    this.headerInverse = !!this.headerElement.classList.contains("header--inverse");
    this.headerNav = this.querySelector("collapsible-header");
    this.mobileNav = this.querySelector("toggle-mobile-navigation");
    this.search = this.querySelector("[data-header-search]");
    this.searchToggle = this.querySelector("toggle-search");
    this.productInfo = document.querySelector("[data-product-info]");

    if (this.headerWrapper) {
      // scroll parameters
      this.currentScrollTop = 0;
      this.scrollOffset = 0;
      this.headerStart = 0;

      if (this.announcementBar) {
        this.announcementBarHeight = this.announcementBar.offsetHeight;
        this.scrollOffset += this.announcementBarHeight;
        this.headerStart += this.announcementBarHeight;
      }

      if (this.headerElement) {
        this.scrollOffset += this.headerElement.offsetHeight;
      }

      // scroll event
      this.raf = null; // Safe request animation frame
      (this.timer = null), // Safe scroll timer
        window.addEventListener(
          "scroll",
          () => {
            clearTimeout(this.timer);
            if (!this.raf) {
              // A request animation frame is used to animate on max 60fps.
              this.raf = requestAnimationFrame(this.scrollAnimation.bind(this));
            }
            this.timer = setTimeout(() => {
              // Stop animation, cancel request animation frame
              cancelAnimationFrame(this.raf);
              this.raf = null;
            }, 50);
          },
          false
        );

      window.addEventListener("resize", () => {
        this.setHeaderHeight();
      }, 100);
    }
 
    this.setHeaderHeight();
  }
  
  // set the value of the css var --header-height by default to: height of the header + optional announcement bar height - scroll position
  setHeaderHeight(height = this.headerWrapper.offsetHeight + (this.announcementBar?.offsetHeight || 0) - document.documentElement.scrollTop) {
    document.documentElement.style.setProperty("--header-height",`${height}px`);
  }

  scrollAnimation() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    // only animate if header is closed.
    if (
      !document.body.classList.contains("menu-drawer-is-open") &&
      !document.body.classList.contains("header-search-is-open")
    ) {
      if (scrollTop + window.innerHeight > document.body.clientHeight) {
        this.hide();
      } else if (
        scrollTop > this.currentScrollTop &&
        scrollTop > this.scrollOffset
      ) {
        this.hide();
      } else if (scrollTop <= this.headerStart) {
        this.revealTop();
      } else if (
        scrollTop < this.currentScrollTop &&
        scrollTop > this.headerStart
      ) {
        this.reveal();
      }
    }

    this.currentScrollTop = scrollTop;

    // Recall request animation loop
    this.raf = requestAnimationFrame(this.scrollAnimation.bind(this));
  }

  hide() {
    this.headerWrapper.classList.add(
      "shopify-section-header--hidden",
      "shopify-section-header--sticky"
    );
    if (this.announcementBar) { 
      this.announcementBar.hide();
    }
    this.closeHeaderNav();
    this.productInfoPosition("up");
    this.setHeaderHeight(0);
    
    const formInput = this.querySelector("form input");
    if (formInput) {
      formInput.value = "";
    }
  }

  reveal() {
    this.headerWrapper.classList.add(
      "shopify-section-header--sticky",
      "shopify-section-header--animate"
    );
    this.headerWrapper.classList.remove("shopify-section-header--hidden");
    if (this.headerInverse) {
      this.headerElement.classList.add("header--inverse-solid");
    }
    this.productInfoPosition("down");
    this.setHeaderHeight(this.headerWrapper.offsetHeight);
  }

  revealTop() {
    if (this.headerInverse && !document.body.classList.contains("header-is-open")) {
      this.headerElement.classList.remove("header--inverse-solid");
    }
    this.headerWrapper.classList.remove(
      "shopify-section-header--hidden",
      "shopify-section-header--sticky",
      "shopify-section-header--animate"
    );
    if (this.announcementBar) {
      this.announcementBar.reveal();
    }
    this.productInfoPosition("up");
    let announcementBarHeight = this.announcementBar.offsetHeight || 0;
    this.setHeaderHeight();
  }

  closeHeaderNav() {
    if (!this.headerNav || window.innerWidth < 768) {
      return false;
    }
    this.headerNav.closeAll();
  }

  closeMobileNav() {
    if (!this.mobileNav) {
      return false;
    }
    this.mobileNav.remove();
  }

  closeSearch() {
    if (!this.search || !this.searchToggle) {
      return false;
    }
    if (this.search.classList.contains("header__search--is-active")) {
      this.searchToggle.remove();
    }
  }

  productInfoPosition(pos = "up") {
    if (!this.productInfo) {
      return;
    }
    if (pos == "down") {
      this.productInfo.classList.add("product-info-col--sticky-with-header");
    } else {
      this.productInfo.classList.remove("product-info-col--sticky-with-header");
    }
  }
}

if (!customElements.get("collapsible-header")) {
  customElements.define("collapsible-header", CollapsibleHeader);
}

if (!customElements.get("announcement-bar")) {
  customElements.define("announcement-bar", AnnouncementBar);
}

if (!customElements.get("toggle-mobile-navigation")) {
  customElements.define("toggle-mobile-navigation", ToggleMobileNavigation);
}

if (!customElements.get("toggle-search")) {
  customElements.define("toggle-search", ToggleSearch);
}

if (!customElements.get("sticky-header")) {
  customElements.define("sticky-header", StickyHeader);
}
